// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2Bu4A","bigColWidth":"Table_bigColWidth__jUtPU","biggerColWidth":"Table_biggerColWidth__HH826","row":"Table_row__2qEus","col":"Table_col__3vvtf"};